import { getRole, ROLES } from './roles';

const AUTH_PATHS = new Set(['login', 'register', 'requestreset', 'resetpassword', 'verify']);
const TENANT_DASHBOARD_PATHS = new Set(['eventi', 'inizia-eventi', 'termina-eventi', 'sondaggi', 'chat-evento', 'iscrizioni', 'profilo']);

export function tenantRoute(pathname, application, search = '') {
  if (!application) return {};
  const parts = pathname.split('/').filter(Boolean);
  if (!parts.length) return { redirect: `/${application.slug}${search}` };
  if (parts.length === 1 && AUTH_PATHS.has(parts[0])) {
    return { redirect: `/${application.slug}/${parts[0]}${search}` };
  }
  if (parts[0] === application.slug) return {};
  if (parts[0] === 'dashboard' && (!parts[1] || TENANT_DASHBOARD_PATHS.has(parts[1]))) return {};
  return { blocked: true };
}

export function tenantSessionAllowed(session, application) {
  if (!session?.sub || !application) return true;
  const role = getRole(session);
  return (role === ROLES.GESTORE || role === ROLES.UTENTE_BASE) &&
    session.application_slug === application.slug &&
    (application.id == null || String(session.application_id) === String(application.id));
}

export function applicationUrl(application, origin = window.location.origin) {
  const base = application.custom_domain ? `https://${application.custom_domain}` : origin;
  return `${base}/${encodeURIComponent(application.slug)}`;
}
